//
// DataSource.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./DataResource";
import "./ItemGroup";
import "@sas-dvr/ltjs-commons/models/data/mapProvider/EsriMapProvider";
import "@sas-dvr/ltjs-commons/models/data/mapProvider/EsriWebMapProvider";
import "@sas-dvr/ltjs-commons/models/data/mapProvider/OpenStreetMapProvider";
import "./BusinessItemFolder";
import "../dataDefinition/common/AppliedFilters";
import "./TimeFrame";
import "./codedItem/CodeBlock";

var DataSource = createModule("BIRD::DataSource", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        hidden: 2,
        itemGroups: [1],
        openStreetMapProvider: 1,
        timeFrames: [1],
        label: 7,
        type: 7,
        codeBlocks: [1],
        esriWebMapProvider: 1,
        appliedFilters: 1,
        name: 7,
        businessItemFolder: 1,
        esriMapProvider: 1,
        dataResource: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DataSource;
